import PropTypes from 'prop-types';
import React from 'react';

import {
  Container,
  Detail,
  OtherDetails,
  ContainerSpace,
  ContainerParticipants,
} from './styles';

import CapResponsesModal from '../cap-responses-modal';

const ApprovalNoTestersFound = ({ project, refetch }) => (
  <Container>
    <OtherDetails>
      Other Details:
    </OtherDetails>

    <Detail>
      Description:
      {' '}
      {project.description}
    </Detail>

    <Detail>
      Created by:
      {' '}
      {project.createdBy.profile.firstName}
      {' '}
      {project.createdBy.profile.lastName}
    </Detail>

    <ContainerSpace>
      <div>
        {project.segments && project.segments.map((segment) => (
          <ContainerParticipants key={segment.id}>
            <Detail>
              {`${segment.name} # Participants: ${segment.audienceParticipants}`}
            </Detail>
            <CapResponsesModal
              label="Response Cap"
              projectId={project.id}
              number={segment.audienceParticipants}
              segmentId={segment.id}
              refetch={refetch}
            />
          </ContainerParticipants>
        ))}
      </div>
    </ContainerSpace>
  </Container>
);

ApprovalNoTestersFound.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string,
    audienceParticipants: PropTypes.number,
    description: PropTypes.string,
    createdBy: PropTypes.shape({
      profile: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      }),
    }),
    segments: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  refetch: PropTypes.func.isRequired,
};

export default ApprovalNoTestersFound;
